export class LazyLoadImage {
    constructor() {
        const lazyImages = [].slice.call(document.querySelectorAll('img[data-src]:not(.swiper-lazy)'));
        const footerImg = document.querySelector('.footer-bg');
        if (lazyImages.length > 0) {
            if ('IntersectionObserver' in window) {
                const lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                    entries.forEach(function (image) {
                        if (image.isIntersecting) {
                            // @ts-ignore
                            image.target.setAttribute('src', image.target.dataset.src);
                            if (image.target.getAttribute('data-srcset')) {
                                // @ts-ignore
                                image.target.setAttribute('srcset', image.target.dataset.srcset);
                            }
                            image.target.classList.remove('opacity-0');
                            image.target.classList.add('opacity-100');
                            lazyImageObserver.unobserve(image.target);
                        }
                    });
                });
                lazyImages.forEach(function (lazyImage) {
                    lazyImageObserver.observe(lazyImage);
                });
            }
        }
        if (footerImg) {
            const loadFooterImg = () => {
                window.removeEventListener('scroll', loadFooterImg);
                if (footerImg.dataset.src) {
                    footerImg.setAttribute('src', footerImg.dataset.src);
                }
            };
            window.addEventListener('scroll', loadFooterImg);
        }
    }
}
